<template>
    <section class="min-h-screen flex items-stretch text-white bg-[#F7F7F7]">
      <!-- Side Menu -->
      <div class="hidden md:flex flex-col justify-between bg-[#090446] text-white w-1/6 p-4">
        <!-- Top Menu -->
        <div class="sticky top-0 bg-[#090446] p-4 z-20">
          <div>
            <p class="text-lg font-semibold">Total Progress: {{
                        progressDetail.totalAnswers1}}/{{
                            progressDetail.totalQuestions1}}
            </p>
            <div class="w-full bg-gray-200 rounded-full h-2.5 mt-2">
                <div class="bg-[#ab064e] h-2.5 rounded-full"
                    :style="{ width: ((progressDetail.totalAnswers1) / (progressDetail.totalQuestions1)) * 100 + '%' }">
                </div>
            </div>
          </div>
        </div>
  
        <!-- Bottom Menu -->
        <div class="mt-auto">
          <router-link to="/privacy-policy" class="text-white hover:text-[#ab064e]">
            Privacy Policy
          </router-link>
        </div>
      </div>
  
      <!-- Main Content -->
      <div class="flex-1 flex items-center justify-center py-6 md:px-16 px-0 z-0">
        <div id="login-card" class="w-full sm:max-w-md lg:max-w-lg mx-auto px-6 py-8 z-20 bg-white rounded-[36px] shadow-lg">
          <div class="flex items-center justify-center mb-6">
            <a href="#" class="flex items-center">
              <img src="../assets/images/logo.png" class="h-24" alt="Logo" />
            </a>
          </div>
  
          <!-- Consent Section -->
          <div v-if="consent">
            <p class="text-lg text-black mb-4">
                Welcome to the <strong> Change and Ambiguity Assessment</strong>! Your organization has invited you to take this assessment to help you better understand yourself and how you approach and adapt to change. This tool will help you gain insight into your comfort level with uncertainty and how you navigate periods of change.
            </p>
            <p class="text-lg text-black mb-4">
                The assessment is designed to take <strong>less than 7-10 minutes. </strong>
            </p>
            <p class="text-lg text-black mb-4">
                Please take your time to respond thoughtfully to each question. Find a quiet space where you can focus on the questions and reflect on your experiences.
            </p>
  
            <!-- Submit Button -->
            <button
            @click.prevent="handleContinue"
            class="relative flex items-center justify-center w-full py-2 text-lg text-white bg-[#0A0446] hover:bg-primary-700 focus:ring-4 focus:ring-primary-200 font-medium rounded-lg text-sm px-5 h-10 py-2.5 text-center">
            <svg v-if="isLoading" class="animate-spin h-5 w-5 text-white absolute" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
              <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
              <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8H4z"></path>
            </svg>
            <span v-else>Instructions</span>
          </button>
  
          </div>
        </div>
      </div>
    </section>
  </template>
  
  
  
  
  <script>
  import Swal from 'sweetalert2'
  import Api from '../router/api'
  import AppMixin from '../mixins/AppMixin'
  
  export default {
    name: 'AssessmentWelcome',
    data() {
      return {
        url: '',
        consent: 1,
        instructions: 0,
        agreement: '', // Use a single data property for radio buttons
        progressDetail: {
          totalQuestions1: 0,
          totalAnswers1: 0,
        },
        isLoading: 0
      }
    },
    mounted() {
      let urlToken = this.$route.fullPath.split('/')[2]
      this.url = urlToken
      this.getProgressBarDetail(this.url);
    },
    methods: {
      getProgressBarDetail(url) {
        Api.getAssessmentProgress(url).then(response => {
          this.progressDetail.totalQuestions1 = response.data.res.totalQuestions1;
          this.progressDetail.totalAnswers1 = response.data.res.totalAnswers1;
        });
      },
      handleContinue() {
        this.isLoading = 1;
        Api.updateSteps(this.url, 1);
        this.$router.push(`/assessment-instruction/${this.url}`);
      },
      submitConsent() {
        this.instructions = true;
        this.consent = false;
      }
    }
  }
  </script>
  
  
  <style scoped>
  .form-group {
    margin-bottom: 1rem;
  }
  .err {
    color: red;
  }
  </style>
  


// WEBPACK FOOTER //
// src/components/AssessmentWelcome.vue